export default "__VITE_ASSET__DEz9Fa8f__"